var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInFocus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.99 0.75c5.94 0 10.74 4.8 10.74 10.73 0 2.6-.92 4.98-2.46 6.84l8.88 8.87-1.56 1.56-8.85-8.85c-1.84 1.47-4.17 2.35-6.71 2.35-5.94 0-10.74-4.8-10.74-10.73S7.05.75 12.99.75zm0 2.2c-4.71 0-8.54 3.82-8.54 8.53s3.83 8.53 8.54 8.53 8.54-3.82 8.54-8.53-3.83-8.53-8.54-8.53z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInFocus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/InFocus.01d5948d459256e6e50b1377e4da847a.svg";